import type {ErrorMessage} from 'angular-error-repository';

import type {DateValidationErrors} from '../validator/date.validator';

export const dateError: ErrorMessage<DateValidationErrors> = info => {
    switch (info.error.code) {
        case 'cannotParse':
            return `Error.Date.Cannot parse`;
        case 'maxDate':
            return `Error.Date.Max exceeded`;
        case 'minDate':
            return `Error.Date.Min exceeded`;
    }
};
